<div class="container">
  <div
    role="button"
    class="title-bar"
    [ariaExpanded]="isExpanded()"
    (click)="toggle.emit()">
    <h3>{{ 'main-menu.apps' | translate }}</h3>
  </div>
  @if (isExpanded()) {
    <coin-siemens-energy-coin-apps-overview
      [isLineManager]="isLineManager()"
      [isHead]="isHead$ | async"
      [cosmosBaseUrl]="environment.cosmosUrl"
      (appsClosed)="closeMenu.emit()"></coin-siemens-energy-coin-apps-overview>
  }
</div>
